import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ApiService} from './api.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private apiService:ApiService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // if (localStorage.getItem('custDD')) {
        //     // logged in so return true
        //     return true;
        // }
        if(this.apiService.getFromLocalData('custDD'))
        {
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/auth.guard.ts